'use strict';

var _ = require('lodash');
var AlertsPanelDataService = function AlertsPanelDataService($q, dataRetrieverService, constants, liteDataService, featureToggleService) {
  var dataRetriever = dataRetrieverService.getDataRetriever(constants.DASHBOARD_SCREEN, constants.MARKET_DASHBOARD_MODE);
  var fimAlertsDataRetriever = dataRetrieverService.getDataRetriever(constants.DASHBOARD_SCREEN, constants.FIM_DASHBOARD_MODE);
  function addNamesToAlerts(rules, alertsNames) {
    _.forOwn(rules, function (rulesList) {
      if (_.isArray(rulesList)) {
        _.forEach(rulesList, function (alert) {
          var alertName = alertsNames[alert.technicalId];
          alert.name = alertName || '(alert rule entry deleted from the system)';
          if (!alertName) {
            alert.notFound = true;
          }
        });
      }
    });
    return rules;
  }
  function getAlertsTechnicalIds(rules) {
    var marketAlertsTechnicalIds = _.map(rules.marketAlerts, 'technicalId'),
      flightAlertsTechnicalIds = _.map(rules.flightAlerts, 'technicalId');
    return _.uniq(marketAlertsTechnicalIds.concat(flightAlertsTechnicalIds));
  }
  function getAlertsNames(rules) {
    var rulesIds = getAlertsTechnicalIds(rules);
    if (rulesIds.length > 0) {
      return getRulesData(rulesIds).then(function (response) {
        return addNamesToAlerts(rules, response.data);
      });
    } else {
      return rules;
    }
  }
  var getRulesData = _.memoize(function (rulesIds) {
    var request = {
      filter: 'technicalId=in=(' + _.join(rulesIds, ',') + ');isUserOverride==false'
    };
    return liteDataService.get('rules/names', request);
  }, function (rulesIds) {
    return rulesIds.join('.');
  });
  function getData() {
    var alertPromises = {
      marketFlightAlerts: dataRetriever.localSortApplied().retrieveComponentData('dashboard-alerts-panel', false).then(getAlertsNames)
    };
    if (featureToggleService.isEnabled('FIM')) {
      alertPromises.fimAlerts = fimAlertsDataRetriever.localSortApplied().retrieveComponentData('dashboard-alerts-panel', false);
    }
    return $q.all(alertPromises).then(function (alertsResponse) {
      var alerts = alertsResponse.marketFlightAlerts;
      if (alertsResponse.fimAlerts) {
        alerts.fimAlerts = alertsResponse.fimAlerts;
        alerts.totalNumber += _.size(alertsResponse.fimAlerts);
      }
      return alerts;
    });
  }
  function getTotalAlertsNumber() {
    return getData().then(function (result) {
      return result.totalNumber;
    });
  }
  return {
    getData: getData,
    getTotalAlertsNumber: getTotalAlertsNumber
  };
};
AlertsPanelDataService.$inject = ['$q', 'DataRetrieverService', 'DataRetrieverConstantsService', 'LiteDataService', 'FeatureToggleService'];
module.exports = AlertsPanelDataService;